
import './filterBar.scss';

export class FilterBarController implements angular.IController {
    $onInit() { }
    disableApplyButton: boolean;
    openFilter: Function;
    closeFilter: Function;
    applyFilter: Function;

    isFilterOpen: boolean;

    open(): void {
        this.isFilterOpen = true;
        this.openFilter();
    }

    close(): void {
        this.isFilterOpen = false;
        this.closeFilter();
    }

    apply(): void {
        this.applyFilter();
        this.close();
    }
}

angular
    .module('deliveryCreate.app')
    .component('filterBar',
    {
        template: require('./filterBar.html'),
        controller: FilterBarController,
        bindings: {
            disableApplyButton: '<',
            openFilter: '&',
            closeFilter: '&',
            applyFilter: '&'
        }
    });


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/filterbar/filterbarcomponent.ts
 **/